module.exports = "/src/views/eternal-dev/businesses/gas-station/images/dark/Ron/header-background.svg";